export const getConfirmAnalysesData = state => state.confirmAnalyses.all;
export const getConfirmAnalysisData = state => state.confirmAnalyses.confirmAnalysis;
export const confirmAnalysesIsFetching = state => state.confirmAnalyses.loading.all;
export const confirmAnalysisIsFetching = state => state.confirmAnalyses.loading.confirmAnalysis;